import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../components/Modal";
import Button from "../../../../components/Button";
import Avatar from "../../../../components/Avatar";
import RetroContent from "./RetroContent";
import { useColumns } from "./columns";
import { renderUserName } from "../../../../utils/helpers/user";

function DetailsModal({ visible, selected, isTeamScheduler, close }) {
    const { t } = useTranslation();
    const [expandedRow, setExpandedRow] = useState({});
    const columns = useColumns({ isTeamScheduler });

    const title = useMemo(() => {
        return (
            <div className="d-flex align-items-center gap-4">
                <div className="d-flex align-items-center gap-2 m-0 p-0">
                    <Avatar user={selected?.user} size={37} />
                    <h3 className="m-0 p-0 text-primary">{renderUserName(selected?.user)}</h3>
                </div>

                <h3 className="m-0 p-0 text-primary">{"("}{t("retro-adjustment-details")}{")"}</h3>
            </div>
        )
    }, [selected?.user, t]);

    useEffect(() => {
        if (selected?.data?.length === 1) {
            const id = selected.data[0].id
            setExpandedRow({ [id]: true });
        }
    }, [selected?.data]);

    return (
        <Modal
            isOpen={visible}
            title={title}
            centered
            size="xl"
        >
            <div className="d-flex gap-2 flex-column" style={{ minHeight: "50vh", maxHeight: "75vh", overflow: "auto" }}>
                {selected?.data?.map((item) => {
                    const hideExpand = selected?.data?.length === 1;
                    return (
                        <RetroContent
                            user={selected?.user}
                            item={item}
                            columns={columns}
                            expandedRow={expandedRow}
                            setExpandedRow={setExpandedRow}
                            hideExpand={hideExpand}
                        />
                    );
                })}
            </div>

            <div className="d-flex justify-content-end">
                <Button color="muted" onClick={close}>
                    {t("close")}
                </Button>
            </div>
        </Modal>
    );
}

export default DetailsModal;
